import React,{ useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Products from './components/Products';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Compnavbar from './components/Compnavbar';
import Form from './components/Form';
import useWindowScrollPosition from "@rehooks/window-scroll-position";



function TestNav() {
  const [change, setChange] = useState(false);
  const changePosition = 300;

  let position = useWindowScrollPosition();
  // position == { x: 0, y: 0 }

  if (position.y > changePosition && !change) {
    setChange(true);
  }

  if (position.y <= changePosition && change) {
    setChange(false);
  }

  let style = {
    backgroundColor: change ? "#621862" : "transparent",
    transition: "400ms ease",
    height: "100px",
    position: "fixed",
    right: 0,
    left: 0,
    top: 0
  };

  return (
    <div style={style}>
      {/* <h1>Logo</h1> */}
    </div>
  );
}

function Spacer() {
  let style = {
    // height: "200vh"
  };

  return <div style={style} />;
}

function App() {
  return (
    <Router>
      <div>
        <Compnavbar />
        <Route exact path="/" component={Home} />
        <Route path="/about" component={About} />
        <Route path="/product" component={Products} />
        <Route path="/service" component={Services} />
        <Route path="/contact" component={Contact} />
        <Route path="/form" component={Form} />
        <TestNav />
        <Spacer />
        <Footer />
      </div>
    </Router>

  );
}

export default App;
